module.exports = {"pageTitleText":"Probes","createText":"新增","hostname":"HostName","serviceIP":"ServiceIP","description":"敘述","status":"狀態","sections":{"essential":"基礎"}}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/zh-TW/probesetting.json
// module id = fZ5h
// module chunks = 3